/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reopen_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Reopen tournament?" |
*
* @param {Reopen_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const reopen_confirm_title = /** @type {((inputs?: Reopen_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reopen_Confirm_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rouvrir le tournoi ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Reabrir el torneo?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reabrir o torneio?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riaprire il torneo?")
	return /** @type {LocalizedString} */ ("Reopen tournament?")
});